// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__1FIwo","requiredAsterisk":"Info_requiredAsterisk__CYccU"};